/**
 * Film page deep link: /pages/film?project=<name> opens that project's window directly.
 * The name is matched loosely against "brand + film title" (case, accents and punctuation ignored).
 * Loaded by snippets/film-data.liquid. Closing the window leaves the visitor on the normal project list.
 */

/* Runs first (loaded before film-showcase.js). On iOS, a non-passive touchmove listener on the window makes every scroll
   on the page, including inside the project window, wait for JavaScript. The page only needs it over the project list,
   so that one listener is attached to #projects instead. Restored right after the page script has started. */
(function () {
  'use strict';
  var add = window.addEventListener;
  window.addEventListener = function (type, fn, opts) {
    var p = type === 'touchmove' && opts && opts.passive === false ? document.getElementById('projects') : null;
    if (p) return p.addEventListener(type, fn, opts);
    return add.apply(this, arguments);
  };
  add.call(window, 'load', function () { window.addEventListener = add; });
})();

(function () {
  'use strict';
  var root = document.documentElement;
  var q = new URLSearchParams(location.search).get('project');
  if (!q) return;

  var norm = function (s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '');
  };
  var done = function () {
    root.classList.remove('fd-wait');
    try {
      var u = new URL(location.href);
      u.searchParams.delete('project');
      history.replaceState(null, '', u.pathname + u.search + u.hash);
    } catch (e) {}
  };

  var key = norm(q), data, target = null;
  try { data = JSON.parse(document.getElementById('film-data').textContent); } catch (e) { return done(); }
  if (!key) return done();
  data.projects.some(function (p) {
    if (norm(p.title + p.film_title).indexOf(key) > -1) { target = p; return true; }
    return false;
  });
  if (!target) return done();

  var full = norm(target.title + target.film_title);
  var label = target.featured ? data.labels.cat_selected : data.labels['cat_' + target.category];

  function findTitle() {
    var all = [].slice.call(document.querySelectorAll('#track .project--title'))
      .filter(function (b) { return norm(b.textContent) === full; });
    return all.filter(function (b) { return !b.hasAttribute('aria-hidden'); })[0] || all[0] || null;
  }

  function open() {
    // 1. land on the project list, as if the visitor had scrolled there
    window.scrollTo(0, Math.max(0, document.documentElement.scrollHeight - window.innerHeight));
    // 2. switch to the category that holds the project
    var cat = [].slice.call(document.querySelectorAll('#cats .category')).filter(function (b) { return b.getAttribute('aria-label') === label; })[0];
    var wait = 60;
    if (cat && cat.getAttribute('aria-pressed') !== 'true') { cat.click(); wait = 700; }
    // 3. click the project: this opens the same window as a normal click
    setTimeout(function () {
      var t = findTitle();
      if (t) t.click();
      setTimeout(done, 150);
    }, wait);
  }

  var start = Date.now();
  var poll = setInterval(function () {
    var ready = document.readyState === 'complete' && document.querySelector('#track .project--title');
    if (ready) { clearInterval(poll); open(); }
    else if (Date.now() - start > 6000) { clearInterval(poll); done(); }
  }, 60);
})();